<template>
  <div class="middle-container">
    <div class="row">
      <div class="col-xs-12">
        <div class="screen-grey-separator legacy-divider-line my-8 m:my-16">
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegacyDividerLine"
}
</script>
